export const internalBaseEquipments = [
  { value: 'true', label: 'Exibir dados de base própria' },
  { value: 'false', label: 'Não exibir dados de base própria' }
]
